var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app",attrs:{"id":"app"}},[_c('router-view'),_c('Biao'),(_vm.$route.meta.keepAlive)?_c('Router',{staticClass:"router"}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }